import { ref, onBeforeUnmount } from 'vue';
import { createConfettiParticles } from '../utils/confetti';

export function useConfetti(canvasRef) {
  const showConfetti = ref(false);
  const confettiParticles = ref([]);
  const animationFrameId = ref(null);

  const startConfetti = () => {
    showConfetti.value = true;
    
    // Wait for next tick to ensure canvas is mounted
    setTimeout(() => {
      const canvas = canvasRef.value;
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      
      // Get the toast container dimensions
      const toastElement = canvas.parentElement;
      const rect = toastElement.getBoundingClientRect();
      
      // Set canvas size to match toast with device pixel ratio for crisp rendering
      const dpr = window.devicePixelRatio || 1;
      
      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;
      canvas.style.width = `${rect.width}px`;
      canvas.style.height = `${rect.height}px`;
      
      ctx.scale(dpr, dpr);

      confettiParticles.value = createConfettiParticles(rect.width, rect.height, {
        particleCount: 25
      });

      const animate = () => {
        if (!showConfetti.value) return;
        
        ctx.clearRect(0, 0, rect.width, rect.height);
        
        confettiParticles.value.forEach(particle => {
          particle.update();
          particle.draw(ctx);
        });

        animationFrameId.value = requestAnimationFrame(animate);
      };

      animate();
    }, 0);
  };

  const stopConfetti = () => {
    if (animationFrameId.value) {
      cancelAnimationFrame(animationFrameId.value);
      animationFrameId.value = null;
    }
    showConfetti.value = false;
    confettiParticles.value = [];
  };

  // Cleanup on unmount
  onBeforeUnmount(() => {
    stopConfetti();
  });

  return {
    showConfetti,
    startConfetti,
    stopConfetti
  };
}
